<script setup>
import { compile, computed, h, provide } from "vue";
import { app } from "@/app.js";
import Image from "./Components/Image.vue";
import Youtube from "./Components/Youtube.vue";
import Instagram from "./Components/Instagram.vue";
import Tiktok from "./Components/Tiktok.vue";
import Facebook from "./Components/Facebook.vue";
import Twitter from "./Components/Twitter.vue";
import CustomHtml from "./Components/CustomHtml.vue";
import { useI18n } from "vue-i18n";

app.component("otoimage", Image);
app.component("otoyoutube", Youtube);
app.component("otoinstagram", Instagram);
app.component("ototiktok", Tiktok);
app.component("otofacebook", Facebook);
app.component("ototwitter", Twitter);
app.component("otocustomhtml", CustomHtml);

const props = defineProps({
    generation: {
        type: Object,
        required: true,
    },
    profiles: {
        type: Array,
        default: [],
    },
});

const { t: __ } = useI18n();

provide("generation", props.generation);

const sanitizedHtml = computed(() => {
    let html = props.generation.html_content;

    const customHtmlList = [];
    let index = 0;

    html = html.replace(/<otocustomhtml[^>]*>([\s\S]*?)<\/otocustomhtml>/gi, (_, inner) => {
        const placeholder = `<otocustomhtml :html="customHtml[${index}]" />`;
        customHtmlList.push(inner);
        index++;
        return placeholder;
    });

    return {
        html,
        customHtmlList,
    };
});

const displayableContent = computed(() => {
    // return h({ render: compile(props.generation.html_content) });

    // console.log(sanitizedHtml.value.html);
    // return h({ render: compile(sanitizedHtml.value.html) });
    return h({
        render: compile(sanitizedHtml.value.html),
        data() {
            return {
                customHtml: sanitizedHtml.value.customHtmlList,
            };
        },
    });
});

const author = computed(() => {
    return props.profiles.find((p) => p.id === props.generation.persona_id);
});
</script>
<template>
    <div class="prose prose-lg prose-slate max-w-none dark:prose-invert">
        <Image v-if="generation.thumbnail" v-bind="generation.thumbnail" :is-thumbnail="true" />

        <component :is="displayableContent"></component>
    </div>
</template>
